class HomeAnimation {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animated');
                }
            });
        });

        const elements = document.querySelectorAll('[data-animated]');
        elements.forEach(el => observer.observe(el));
    }
}

export default HomeAnimation
